// src/com/file_of_report/TempBreakReportGql.js
import { gql } from "@apollo/client";

/*

extend type Mutation {
    dcTempBreakReportAdd(tempBreakReport: InputTempBreakReportAdd!): ResponseWithFileCreateHisItem!
}

# 온도관제 레포트 조회용 입력.
input InputTempBreakReportAdd {
    dateFrom: String!
    dateTill: String!
}

*/

export const CREATE_TEMP_BREAK_REPORT = gql`
mutation CreateTempBreakReport($tempBreakReport:InputTempBreakReportAdd!) {
    dcTempBreakReportAdd(tempBreakReport: $tempBreakReport) {
        ok
        message
        item {
            fileCreateHisSeq
        }
    }
}
`;
